export class AppVersion {
public static appVersion = '1.7.2';
}
